module.exports = __webpack_public_path__ + "static/cat_dash-e1d1f083ad824378c82a563875262420.gif";